import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';

import routes from './routes';

Vue.use(Router);

const index = new Router({
  routes,
  mode: 'history',
});


index.beforeEach((to, from, next) => {
  // Si no esta logueado, redirigir a login
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      next({
        name: 'login',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  }

  next();
});

export default index;
